import { Box } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
import { CompletedTask } from '../../rule-layout/completed-task/completed-task';
export const EvergreenRuleFixer = _ref => {
  let {
    ruleResult
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.evergreenRule(ruleResult.dataHook),
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(CompletedTask, {
    dataHook: dataHooks.evergreenRuleCompletedTask(ruleResult.dataHook),
    description: ruleResult.description,
    isEditable: false,
    title: ruleResult.fixerProps.completedRuleContent.title
  }));
};
//# sourceMappingURL=evergreen-rule-fixer.js.map